<template src='./FeatureConfigList.html'></template>
<script>
import { orderBy } from "@progress/kendo-data-query";
import CommandCell from "@/components/CommandCellTemplate.vue";
// import { createNamespacedHelpers } from "vuex";
// import { state } from "../../store/entities";
// const { mapState } = createNamespacedHelpers("featureConfig");
// import { MESSAGES } from "@/utils/constants";
// import { notify, notifyApiError } from "@/utils/notification-helper";

export default {
  data: function() {
    return {
      // addoredit: false,
      gridData: [],
      skip: 0,
      data: {},
      take: 10,
      pageSize: 10,
      editField: false,
      pageable: {
        pageSizes: true,
        previousNext: true
      },
      name: [
        { name: "Gold", id: 1 },
        { name: "Silver", id: 2 },
        { name: "Bronze", id: 3 }
      ],
      type: [
        { name: "General", id: 1 },
        { name: "Addon", id: 2 }
      ],
      defaultItem: {
        name: "--Select--"
      },
      add: true,
      sort: [{ field: "name", dir: "asc" }],
      columns: [
        // { field: "id", title: "ID" },
        { field: "name", title: "Name" },

        { field: "type", title: "Type" },

        { cell: CommandCell, title: "Actions", width: "200px" }
      ],
      dataItems: []
    };
  },
  methods: {
    sortChangeHandler: function(e) {
      this.sort = e.sort;
    },
    pageChangeHandler: function(event) {
      this.skip = event.page.skip;
      this.take = event.page.take;
    },
    showAdd: function() {
      this.add = true;
    },
    remove: function(item) {
      return this.$store
        .dispatch("featureConfig/removeFeature", item.dataItem)
        .then(() => {
          //   notify(MESSAGES.CHANGES_SAVE_SUCCESS);
        });
      // .catch(notifyApiError);
    },
    edit: function(item) {
      this.editField = true;
      this.openWindow();
      // return this.$store.dispatch("featureConfig/editFeature", item.dataItem); //item.dataItem.id

      this.data = item.dataItem;
      this.data.name = this.name.find(obj => obj.name == this.data.name);
      this.data.type = this.type.find(obj => obj.name == this.data.type);
    },
    addForm() {
      if (this.data.name && this.data.type) {
        let dataVal = {
          name: this.data.name.name,
          type: this.data.type.name
        };
        if (!this.editField) {
          this.$store.dispatch("featureConfig/addFeature", dataVal).then(() => {
            this.getDataOnload();
          });
        } else {
          dataVal.id = this.data.id;
          this.$store
            .dispatch("featureConfig/updateFeature", dataVal)
            .then(() => {
              this.getDataOnload();
            });
        }
        var window = this.$refs.windowRef.kendoWidget();
        window.center().close();
      }
      // this.$router.push({ name: "Package" });
    },
    async getDataOnload() {
      this.$store.dispatch("getFeature");
    },
    openForm() {
      this.editField = false;
      this.data = {};
      this.openWindow();
    },
    openWindow() {
      var window = this.$refs.windowRef.kendoWidget();
      window.center().open();
    }
  },
  computed: {
    // ...mapState({
    //   featureList: state => state.features
    // }),
    featureList() {
      return this.$store.state.features;
    },
    total() {
      return this.featureList ? this.featureList.length : 0;
    },
    items: {
      get: function() {
        return orderBy(
          this.featureList.slice(this.skip, this.take + this.skip),
          this.sort
        );
      }
    }
  },
  created: function() {
    this.getDataOnload();
  }
};
</script>
